import React from "react";
import Hero from "../components/hero/BackgroundAsImageWithCenteredContent";
import AboutUs from "../pages/AboutUs";
import Services from "../pages/Services";
import Footer from "../components/footers/FiveColumnWithInputForm";
import ContactUS from "../pages/ContactUS";

export default function EventLandingPage() {
  return (
    <>
      <div id="home"><Hero /></div>
      <div id="about"><AboutUs /></div>
      <div id="services"><Services /></div>
      <div id="contactus"><ContactUS/></div>
      <Footer />
    </>
  );
}
